<template>
  <div>
    <div class="hint p-2 mt-1 mb-3 border-radius">
      {{ $t('vform.stepNavigationSettingsInfo') }}
    </div>

    <!-- Alignment -->
    <div :class="['dflex mt-2', state && state.isTopBottomBarPanel ? 'section-disabled' : '']">
      <div class="col row">
        <label class="vform-editor-label section mt-0">
          {{ $t('alignment') }}
          <span v-if="state && state.isTopBottomBarPanel" class="disabled-hint">({{ $t('vform.notApplicableInBar') }})</span>
        </label>
      </div>
      <set-by-template v-if="selectedTemplate && selectedTemplate.alignment"/>
      <div
          v-else
          v-for="(align, index) in alignments"
          :key="index"
          :class="['vform-alignment-button', align === element.alignment ? 'active' : '', state && state.isTopBottomBarPanel ? 'disabled' : '']"
          @click="state && state.isTopBottomBarPanel ? null : setAlignment(align)">
        <icon :type="'align-' + align" size="1"/>
      </div>
    </div>


    <!-- Button Color -->
    <label class="vform-editor-label section mt-2">{{ $t('vform.buttonColor') }}</label>
    <set-by-template v-if="!templateEditing && !isObjectEmpty(selectedTemplate)" />
    <color-picker-and-field
        v-else
        :field-background-color="element.buttonColor || '#ffffff'"
        @saveColor="(color) => setItemColor('buttonColor', color)"
        @unsetColor="setItemColor('buttonColor', null)"
    />

    <!-- Button Background Color -->
    <label class="vform-editor-label section mt-2">{{ $t('vform.buttonBackgroundColor') }}</label>
    <set-by-template v-if="!templateEditing && !isObjectEmpty(selectedTemplate)" />
    <color-picker-and-field
        v-else
        :field-background-color="element.buttonBackgroundColor || '#444444'"
        @saveColor="(color) => setItemColor('buttonBackgroundColor', color)"
        @unsetColor="setItemColor('buttonBackgroundColor', null)"
    />

    <!-- Active (current step) Button Color -->
    <label class="vform-editor-label section mt-2">{{ $t('vform.activeButtonColor') }}</label>
    <set-by-template v-if="!templateEditing && !isObjectEmpty(selectedTemplate)" />
    <color-picker-and-field
        v-else
        :field-background-color="element.activeColor || '#ffffff'"
        @saveColor="(color) => setItemColor('activeColor', color)"
        @unsetColor="setItemColor('activeColor', null)"
    />

    <!-- Active (current step) Button Background Color -->
    <label class="vform-editor-label section mt-2">{{ $t('vform.activeButtonBackgroundColor') }}</label>
    <set-by-template v-if="!templateEditing && !isObjectEmpty(selectedTemplate)" />
    <color-picker-and-field
        v-else
        :field-background-color="element.activeBackgroundColor || '#0066cc'"
        @saveColor="(color) => setItemColor('activeBackgroundColor', color)"
        @unsetColor="setItemColor('activeBackgroundColor', null)"
    />
  </div>
</template>

<script>
import vFormElementMixin from "@/components/vForm/vFormElementMixin.js.vue";
import SetByTemplate from "@/components/vForm/SetByTemplate.vue";
import ColorPickerAndField from "@/components/widgets/editors/ColorPickerAndField.vue";
import Icon from "@/components/Icon.vue";

export default {
  name: "vFormSTEP_NAVIGATION",
  components: {
    SetByTemplate,
    ColorPickerAndField,
    Icon,
  },
  mixins: [vFormElementMixin],
  data() {
    return {
      alignments: ['left', 'center', 'right', 'justify'],
    };
  },
  beforeMount() {
    if (!this.element.alignment) {
      this.$set(this.element, 'alignment', 'left');
    }
    // Ensure defaults are written once so the viewer always has a value
    if (!this.element.buttonColor) {
      this.$set(this.element, 'buttonColor', '#ffffff');
    }
    if (!this.element.buttonBackgroundColor) {
      this.$set(this.element, 'buttonBackgroundColor', '#444444');
    }
    if (!this.element.activeColor) {
      this.$set(this.element, 'activeColor', '#ffffff');
    }
    if (!this.element.activeBackgroundColor) {
      this.$set(this.element, 'activeBackgroundColor', '#0066cc');
    }
  },
  methods: {
    setAlignment(val) {
      this.$set(this.element, 'alignment', val);
    },
  },
};
</script>

<style scoped lang="scss">
.hint {
  background-color: var(--vform-editor-ui-secondary-color);
}

.section-disabled {
  opacity: 0.4;
  pointer-events: none;
}

.disabled-hint {
  font-size: 0.75em;
  margin-left: 4px;
  opacity: 0.8;
  text-transform: none;
  font-weight: normal;
}
</style>

